export default "__VITE_PUBLIC_ASSET__313a3f99__"